import React,{Component} from "react";
import Header from "../components/Header";




class Home extends React.Component{

	constructor(props) {
        super(props);
        this.state = {
			 properties:[],
			 isLoaded:false,
        };
      }
//https://api.test.takengo.risee.in/index.php/rest/items/get/api_key/1fWwZNrzUiOW2pWEffgy3fXS1R7khL/id/itm_f90d921abee06a6a355afb4958cb9187/limit/2/

componentDidMount(){
	fetch("https://api.test.takengo.risee.in/index.php/rest/items/get/api_key/1fWwZNrzUiOW2pWEffgy3fXS1R7khL/limit/6/")
	  .then(response => response.json())
	  .then(data =>	this.setState({ isLoaded:true, properties:data,  }))
	  .catch(error => console.log(error));
};
    render(){
		 var {properties, isLoaded} = this.state;
 
        return(
            <div>
				
                  {/*<!-- Header Container -->*/}
				  <Header home="current"/>
                  {/*<!-- Header Container / End -->*/}

                  
                  {/*<!-- Banner -->*/}
                  <div className="parallax" style={{backgroundImage:"url(assets/images/home-parallax-3.jpg)", backgroundAttachment:"fixed", backgroundSize:"1838px 1176.32px", backgroundPosition:"50% -222.269px"}}>
				    <div class="parallax-overlay" style={{backgroundColor:"rgb(54, 56, 62)", opacity: "0.7"}}></div>
			        <div className="container" >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="search-container"> 
                            <h2>Find Your Dream Property Now in Hyderabad</h2>
                			<div className="announce">From as low as $10 per day with limited time offer discounts.</div>
                            <div className="row with-forms"> 
                			  {/*<!-- Select City -->*/}
                			  <div className="col-md-2">
                				  <select data-placeholder="Select City" title="Select City" onChange={this.homesearchData} className="utf-chosen-select-single-item">
                					<option>Select City</option>
                					<option>Afghanistan</option>
                					<option>Albania</option>
                					<option>Algeria</option>
                					<option>Brazil</option>
                					<option>Burundi</option>
                					<option>Bulgaria</option>
                					<option>California</option>
                					<option>Germany</option>
                					<option>Grenada</option>
                					<option>Guatemala</option>
                					<option>Iceland</option>                        
                				  </select>
                			  </div>
                					
                              {/*<!-- Property Type -->*/}
                              <div className="col-md-2">
                                <select data-placeholder="Property Type" className="utf-chosen-select-single-item" onChange={this.homesearchData}>
                                  <option>Property Type</option>
                				  <option>Residential</option>
                				  <option>Apartments</option>
                                  <option>Houses</option>
                                  <option>Commercial</option>
                                  <option>Land</option>
                                </select>
                              </div>
                              
                              {/*<!-- Status -->*/}
                              <div className="col-md-2">
                                <select data-placeholder="Any Status" className="utf-chosen-select-single-item" onChange={this.homesearchData}>
                				  <option>Any Status</option>
                                  <option>For Sale</option>
                                  <option>For Rent</option>
                                </select>
                              </div>
                              
                              {/*<!-- Main Search Input -->*/}
                              <div className="col-md-6">
                                <div className="utf-main-search-input-item">
                                  <input type="text" placeholder="Enter Keywords..." onChange={this.homesearchData}/>
                                  <button className="button"><i className="fa fa-search"></i> Search</button>
                                </div>
                              </div>
                            </div>
                			<div className="row">
                			  <h4 className="utf-cat-home-item-list">What are you looking for?</h4>
                				<ul className="utf-home-iconbox">
                					<li className="list-inline-item"><div className="icon"><span className="icon-line-awesome-building"></span><p>Modern Villa</p></div></li>
                					<li className="list-inline-item"><div className="icon"><span className="icon-feather-home"></span><p>Family House</p></div></li>
                					<li className="list-inline-item"><div className="icon"><span className="icon-material-outline-location-city"></span><p>Town House</p></div></li>
                					<li className="list-inline-item"><div className="icon"><span className="icon-material-outline-business"></span><p>Apartment</p></div></li>
                				</ul>
                			</div>
                            {/*<!-- Row With Forms / End -->*/} 
                          </div>		  
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/*<!-- Featured -->*/}
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 margin-top-75">	
                		<div className="utf-section-headline-item centered margin-bottom-30 margin-top-0">
                		  <h3 className="headline"><span>Most Featured Properties</span> Featured Properties</h3>
                		  <div className="utf-headline-display-inner-item">Most Featured Properties</div>
                		  <p className="utf-slogan-text">Lorem Ipsum is simply dummy text printing and type setting industry Lorem Ipsum been industry standard dummy text ever since when unknown printer took a galley.</p>
                		</div>  
                	  </div>
                 	
		         	 {isLoaded ? properties.map(properties => (
		     				 // <!-- Listing Item -->
		     				 <div className="col-md-4">
							    <div className="">	  
		     					    <div className="utf-listing-item compact"> 
		     					      <a href="single-property-page-2.html" className="utf-smt-listing-img-container">
		     					    	  <div className="utf-listing-badges-item"> <span className="featured">Featured</span> <span className="for-sale">For {properties.item_type_id == 4 ? 'Sale' : null}</span> </div>
		     					    	  <div className="utf-listing-img-content-item"> 
		     					    		 <span className="utf-listing-compact-title-item">{properties.title} <i> $ {properties.price}</i></span>
		     					    	  </div>
		     					    	  <img src={properties.default_photo.img_path == '' ? "assets/images/listing-02.jpg" : "https://api.test.takengo.risee.in/uploads/"+properties.default_photo.img_path } alt=""  style={{height:"260px"}} /> 
		     					    	  <ul class="listing-hidden-content">
		     					    		  {properties.numberofbedrooms == '' || properties.numberofbedrooms == 0  ? '' : <li style={{padding:"10px"}}><i className="fa fa-bed"></i> Beds <span>{properties.numberofbedrooms}</span></li>}
		     			                      {properties.numberofbathrooms == '' || properties.numberofbathrooms == 0 ? '' : <li style={{padding:"10px"}}><i className="icon-feather-codepen"></i> Baths <span>{properties.numberofbathrooms}</span></li>}
		     					    		  {properties.car_parking == '' || properties.car_parking == 0 ? '' : <li style={{padding:"10px"}}><i className="fa fa-car"></i> Parking <span>{properties.car_parking}</span></li>}
		     					    		  {properties.area == '' || properties.area == 0 ? '' : <li style={{padding:"10px"}}><i className ="fa fa-arrows-alt"></i> {properties.area_type} <span>{properties.area}</span></li>}			
		     					    	  </ul>
		     					      </a> 
		     					    </div>
								</div>	 
		     				</div>				  
		     				//<!-- Listing Item / End -->
		     		 )) : <h2 className="text-center py-5">Loading...</h2> }         
		     
      
                    </div>
                  </div>
                  {/*<!-- Featured / End -->*/} 
                  
				  {/*
                  <section className="fullwidth margin-top-65 margin-bottom-0 padding-bottom-80 padding-top-75" data-background-color="#f7f7f7">
                    <div className="container">
                      <div className="row">
                          <div className="col-md-12">	
                			<div className="utf-section-headline-item centered margin-bottom-0 margin-top-0">
                			  <h3 className="headline"><span>Clients Say About Us</span> What Our Clients Say</h3>
                			  <div className="utf-headline-display-inner-item">Clients Say About Us</div>
                			  <p className="utf-slogan-text">Lorem Ipsum is simply dummy text printing and type setting industry Lorem Ipsum been industry standard dummy text ever since when unknown printer took a galley.</p>
                			</div>  
                		  </div>
                		  <div className="col-md-12">
                			<div className="testimonial-carousel"> 
                			  <div className="utf-carousel-item-area">
                				<div className="utf-listing-item utf-testimonial-item-box-area"> 
                				   <div className="utf-testimonial-box">
                						<div className="testimonial">Lorem Ipsum is simply dummy text of the printing and type setting industry. Lorem Ipsum has been the industry's standard dummy text ever since, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and type setting industry galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</div>
                						<div className="testimonial-author"> <img src="assets/images/happy-client-01.jpg" alt=""/>
                						  <h4>John Williams <span>Real Estate Agent</span></h4>
                						</div>
                					</div>
                				</div>
                			  </div>
                			  
                			  <div className="utf-carousel-item-area">
                				<div className="utf-listing-item utf-testimonial-item-box-area"> 
                				   <div className="utf-testimonial-box">
                						<div className="testimonial">Lorem Ipsum is simply dummy text of the printing and type setting industry. Lorem Ipsum has been the industry's standard dummy text ever since, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and type setting industry galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</div>
                						<div className="testimonial-author"> <img src="assets/images/happy-client-03.jpg" alt=""/>
                						  <h4>John Williams <span>Real Estate Agent</span></h4>
                						</div>
                					</div>
                				</div>
                			  </div>
                
                			  <div className="utf-carousel-item-area">
                				<div className="utf-listing-item utf-testimonial-item-box-area"> 
                				   <div className="utf-testimonial-box">
                						<div className="testimonial">Lorem Ipsum is simply dummy text of the printing and type setting industry. Lorem Ipsum has been the industry's standard dummy text ever since, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and type setting industry galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</div>
                						<div className="testimonial-author"> <img src="assets/images/happy-client-02.jpg" alt=""/>
                						  <h4>John Williams <span>Real Estate Agent</span></h4>
                						</div>
                					</div>
                				</div>
                			  </div>
                			  
                			  <div className="utf-carousel-item-area">
                				<div className="utf-listing-item utf-testimonial-item-box-area"> 
                				   <div className="utf-testimonial-box">
                						<div className="testimonial">Lorem Ipsum is simply dummy text of the printing and type setting industry. Lorem Ipsum has been the industry's standard dummy text ever since, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and type setting industry galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</div>
                						<div className="testimonial-author"> <img src="assets/images/happy-client-01.jpg" alt=""/>
                						  <h4>John Williams <span>Real Estate Agent</span></h4>
                						</div>
                					</div>
                				</div>
                			  </div>
                			
                			  <div className="utf-carousel-item-area">
                				<div className="utf-listing-item utf-testimonial-item-box-area"> 
                				   <div className="utf-testimonial-box">
                						<div className="testimonial">Lorem Ipsum is simply dummy text of the printing and type setting industry. Lorem Ipsum has been the industry's standard dummy text ever since, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and type setting industry galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</div>
                						<div className="testimonial-author"> <img src="assets/images/happy-client-02.jpg" alt=""/>
                						  <h4>John Williams <span>Real Estate Agent</span></h4>
                						</div>
                					</div>
                				</div>
                			  </div>
                			</div>
                		  </div>
                      {/*<!-- Carousel / End -->*/}   
					  {/*    
                      </div>
                    </div>
                  </section>	
					  */}
                  {/*<!-- Photo Section -->*/}
                	<div className="utf-photo-section-block margin-bottom-70">
                		<div className="utf-photo-text-content white-font">
                			<div className="container">
                				<div className="row">
                					<div className="col-lg-8 col-md-12 col-sm-12">
                						<h2>Download Browse Hundreds of Properti</h2>
                						<p>Lorem Ipsum is simply dummy text of printing and type setting industry. Lorem Ipsum been industry standard dummy text ever since, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic type setting, remaining essentially unchanged. It was popularised.</p>						
                						<ul className="utf-download-text">
                							<li>
                								<a href="#" className="tooltip top" title="Windows App">
                									<i className="icon-line-awesome-windows"></i>
                									<span>Windows</span>
                									<p>Available Now</p>
                								</a>
                							</li>
                							<li>
                								<a href="#" className="tooltip top" title="App Store">
                									<i className="icon-line-awesome-apple"></i>
                									<span>App Store</span>
                									<p>Available Now</p>
                								</a>
                							</li>
                							<li>
                								<a href="#" className="tooltip top" title="Google Play">
                									<i className="icon-line-awesome-android"></i>
                									<span>Google Play</span>
                									<p>Get in On</p>
                								</a>
                							</li>
                						</ul>
                					</div>
                					<div className="col-lg-4 col-md-6 col-sm-12">
                						<div className="download-img">
                							<img src="assets/images/mockup3.png" alt=""/>
                						</div>
                					</div>
                				</div>
                			</div>
                		</div>
                	</div>
                  {/*<!-- Photo Section / End -->*/}
                  
                  {/*<!-- Container -->*/}
                  <div className="container">
                    <div className="row">
                        <div className="col-md-12">	
                			<div className="utf-section-headline-item centered margin-bottom-30 margin-top-0">
                			  <h3 className="headline"><span>Most Popular Places</span> Most Popular Properties Places</h3>
                			  <div className="utf-headline-display-inner-item">Most Popular Places</div>
                			  <p className="utf-slogan-text">Lorem Ipsum is simply dummy text printing and type setting industry Lorem Ipsum been industry standard dummy text ever since when unknown printer took a galley.</p>
                			</div>  
                		</div>
                        <div className="col-md-4 col-sm-6"> 
                		  <a href="listings-list-with-sidebar.html" className="img-box">
                			  <div className="utf-listing-badges-item"> <span className="featured">Featured</span> </div>
                			  <img src="assets/images/popular-location-01.jpg" alt="" />
                			  <div className="utf-cat-img-box-content visible">
                				<h4>Afghanistan</h4>
                				<span>14 Properties</span> 
                			  </div>
                          </a> 
                		</div>
                        <div className="col-md-3 col-sm-6"> 
                		  <a href="listings-list-with-sidebar.html" className="img-box">
                		      <img src="assets/images/popular-location-02.jpg" alt="" /> 
                			  <div className="utf-cat-img-box-content visible">
                				<h4>Australia</h4>
                				<span>24 Properties</span> 
                			  </div>
                          </a> 
                		</div>
                        <div className="col-md-5 col-sm-6"> 
                		  <a href="listings-list-with-sidebar.html" className="img-box">
                			  <div className="utf-listing-badges-item"> <span className="featured">Featured</span> </div>
                			  <img src="assets/images/popular-location-03.jpg" alt="" />
                			  <div className="utf-cat-img-box-content visible">
                				<h4>Bangladesh</h4>
                				<span>12 Properties</span> 
                			  </div>
                          </a> 
                		</div>
                        <div className="col-md-5 col-sm-6"> 
                		  <a href="listings-list-with-sidebar.html" className="img-box">
                			  <div className="utf-listing-badges-item"> <span className="featured">Featured</span> </div>
                			  <img src="assets/images/popular-location-04.jpg" alt="" />
                			  <div className="utf-cat-img-box-content visible">
                				<h4>Miami</h4>
                				<span>9 Properties</span> 
                			  </div>
                          </a> 
                		</div>
                		<div className="col-md-4 col-sm-6"> 
                			<a href="listings-list-with-sidebar.html" className="img-box"> 
                			    <img src="assets/images/popular-location-05.jpg" alt="" />
                				<div className="utf-cat-img-box-content visible">
                				  <h4>Belize</h4>
                				  <span>14 Properties</span> 
                				</div>
                			</a> 
                		  </div>
                		  <div className="col-md-3 col-sm-6"> 
                			<a href="listings-list-with-sidebar.html" className="img-box">
                			    <img src="assets/images/popular-location-06.jpg" alt="" />
                				<div className="utf-cat-img-box-content visible">
                				  <h4>Cambodia</h4>
                				  <span>24 Properties</span> 
                				</div>
                			</a> 
                		  </div>		  
                      </div>
                	  <div className="utf-centered-button margin-top-10">
                		<a href="all-categorie.html" className="button">View All Categories</a> 
                	  </div>
                  </div>
                  {/*<!-- Container / End -->*/} 
                  
                  {/*<!-- Parallax -->*/}
                  <div className="parallax margin-top-70"  style={{backgroundImage:"url(assets/images/listings-parallax.jpg)", backgroundAttachment:"fixed", backgroundSize:"1838px 1160.24px", backgroundPosition: "50% -249.628px"}}> 
                    {/*<!-- Infobox -->*/}
                    <div className="text-content white-font" style={{backgroundColor:"rgb(48, 48, 48)", opacity:"0.8"}}>
                      <div className="container">
                        <div className="row">
                          <div className="col-lg-6 col-sm-12 col-sm-push-3 smart-utf-listing-item">
                            <h2>Search Smarter, From Anywhere</h2>
                            <p>Power your search with our Resideo real estate platform, for timely listings and a seamless experience.</p>
                            <a href="listings-list-with-sidebar.html" className="button margin-top-15">Search Now</a> 
                		  </div>
                        </div>
                      </div>
                    </div>
                    {/*<!-- Infobox / End -->*/}     
                  </div>
                  {/*<!-- Parallax / End -->*/}
                
                  {/*<!-- Fullwidth Section -->*/}
                  <section className="fullwidth margin-bottom-0" data-background-color="linear-gradient(to bottom,rgba(0,0,0,0.03) 0%,rgba(255,255,255,0))">
                    <div className="container">
                      <div className="row">
                        <div className="col-md-12">	
                			<div className="utf-section-headline-item centered margin-bottom-30 margin-top-0">
                			  <h3 className="headline"><span>Our Blog & Articles</span> Latest Blog Post</h3>
                			  <div className="utf-headline-display-inner-item">Our Blog & Articles</div>
                			  <p className="utf-slogan-text">Lorem Ipsum is simply dummy text printing and type setting industry Lorem Ipsum been industry standard dummy text ever since when unknown printer took a galley.</p>
                			</div>  
                		</div>
                        <div className="col-md-4"> 
                          <div className="blog-post"> 
                            <a href="blog_detail_right_sidebar.html" className="post-img"> <img src="assets/images/blog-post-01.jpg" alt=""/> </a> 
                            <div className="utf-post-content-area">
                			  <h3><a href="blog_detail_right_sidebar.html">What It Really Takes to Make $100k Before You Turn 30</a></h3>
                			  <ul className="utf-blog-item-post-list">
                				<li>By, John Williams</li>	
                				<li>20 Jan, 2020</li>
                			  </ul>
                			  <p>Lorem Ipsum is simply dummy text of printing industry Lorem Ipsum been industry standard dummy text since book.</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4"> 
                          <div className="blog-post"> 
                            <a href="blog_detail_right_sidebar.html" className="post-img"> <img src="assets/images/blog-post-02.jpg" alt=""/> </a> 
                            <div className="utf-post-content-area">
                			  <h3><a href="blog_detail_right_sidebar.html">The Best Canadian Merchant Account Providers.</a></h3>
                			  <ul className="utf-blog-item-post-list">
                				<li>By, John Williams</li>	
                				<li>20 Jan, 2020</li>
                			  </ul>
                			  <p>Lorem Ipsum is simply dummy text of printing industry Lorem Ipsum been industry standard dummy text since book.</p>
                            </div>
                          </div>          
                        </div>
                        <div className="col-md-4"> 
                          <div className="blog-post"> 
                            <a href="blog_detail_right_sidebar.html" className="post-img"> <img src="assets/images/blog-post-03.jpg" alt=""/> </a> 
                            <div className="utf-post-content-area">
                			  <h3><a href="blog_detail_right_sidebar.html">Hey Job Seeker, It’s Time To Get Up And Get Hired.</a></h3>
                			  <ul className="utf-blog-item-post-list">
                				<li>By, John Williams</li>	
                				<li>20 Jan, 2020</li>
                			  </ul>
                			  <p>Lorem Ipsum is simply dummy text of printing industry Lorem Ipsum been industry standard dummy text since book.</p>
                            </div>
                          </div>          
                        </div>
                      </div>
                    </div>
                  </section>
                  {/*<!-- Fullwidth Section / End -->*/} 
                  
 
            </div>
        )
    }
}

export default Home;